import svListOrValue from '../locales/sv/listOrValue.json';
import enListOrValue from '../locales/en/listOrValue.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getListOrValueLocale = (lang?: Language) => {
  const l = lang || getLanguage();
  return l === 'en' ? enListOrValue : svListOrValue;
};

export const listOrValueLabels = (lang?: Language) => getListOrValueLocale(lang);
